let previousEventListener = () => {
  //
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('tooltip', {
    updated(el, binding) {
      const { modifiers, value } = binding
      const message = value
      const { createTooltip } = useTooltipLayerStore()
      const position = modifiers.left
        ? 'left'
        : modifiers.bottom
        ? 'bottom'
        : modifiers.right
        ? 'right'
        : 'top'

      if (message && window.innerWidth > parseInt(breakpoints.md)) {
        el.removeEventListener('mouseenter', previousEventListener)
        previousEventListener = () => createTooltip(message, el, { position })
        el.addEventListener('mouseenter', previousEventListener)
      } else {
        el.removeEventListener('mouseenter', previousEventListener)
      }
    },
  })
})
